import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getLoginAgainUrl } from '../../utils/loginUrl';
import { resolveSessionActive } from '../../utils/sessionProbe';

// Gate for the agentic (/apps, /intake-agent, etc.) subtree.
//
// As of 2026-06-02 the agentic FA accepts BFF-minted JWTs (see
// utils/agenticApiClient.js) instead of a second Entra app registration, so
// this component no longer triggers an Azure AD redirect. It re-checks the
// Track 1 session that AppRoutes already verified — if the session has lapsed
// between AppRoutes mounting and this child route rendering, we bounce to the
// signin portal rather than letting the agentic FA return 401s after paint.
//
// Detection uses resolveSessionActive(): the readable `session_exists` cookie
// on vanity domains, or a credentialed BFF probe on default
// *.azurewebsites.net hosts where that cookie is host-only and unreadable from
// this SPA host (Public Suffix List rule). See utils/sessionProbe.js.

const AgenticProtectedRoute = () => {
  const [checked, setChecked] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    resolveSessionActive().then((ok) => {
      if (cancelled) return;
      if (!ok) {
        // Track 1 session is gone — restart sign-in. AppRoutes does the same
        // thing on first mount; this is the lapsed-mid-session case. A false
        // result maps deterministically to login (no retry), so no loop.
        window.location.replace(getLoginAgainUrl());
        return;
      }
      setAllowed(true);
      setChecked(true);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!checked) return null;
  if (!allowed) return <Navigate to="/" replace />;

  return <Outlet />;
};

export default AgenticProtectedRoute;
